/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Check_In_Guest_DescriptionInputs */

const en_check_in_guest_description = /** @type {(inputs: Check_In_Guest_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get 30 welcome credits, then earn 30 more across your first 7 check-ins. Days 8-12 unlock creative prompt packs.`)
};

const es_check_in_guest_description = /** @type {(inputs: Check_In_Guest_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtén 30 créditos de bienvenida y 30 más en tus primeros 7 registros. Los días 8-12 desbloquean packs de prompts creativos.`)
};

/**
* | output |
* | --- |
* | "Get 30 welcome credits, then earn 30 more across your first 7 check-ins. Days 8-12 unlock creative prompt packs." |
*
* @param {Check_In_Guest_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const check_in_guest_description = /** @type {((inputs?: Check_In_Guest_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Check_In_Guest_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_check_in_guest_description(inputs)
	return es_check_in_guest_description(inputs)
});